import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("chartshub_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Expired/invalid session: drop the dead token and tell the admin page to show
// the login screen again (instead of a bare "update failed" error)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("chartshub_token")) {
      localStorage.removeItem("chartshub_token");
      window.dispatchEvent(new Event("admin-session-expired"));
    }
    return Promise.reject(err);
  }
);

export function chartFileUrl(chart) {
  return `${API}/files/${chart.storage_path || chart.url.replace("/api/files/", "")}`;
}

export function absoluteShareUrl(chart) {
  return `${BACKEND_URL}/api/files/${chart.url.replace("/api/files/", "")}`;
}

export default api;
